<template>
  <main id="js-page-content" role="main" class="page-content">
    <div class="row">
      <div class="subheader col-md-6">
        <h1 class="subheader-title">
          <!-- フュージョンアウトドア 業務管理システム -->
          <small>
            {{ new Date().toLocaleString() }}　<span
              >ログインユーザー： {{ $store.state.name }}
              <sup
                class="badge badge-danger fw-500 attendanceBadge"
                v-if="attendaceStatus == '未出勤'"
                >未出勤</sup
              >
              <sup
                class="badge badge-info fw-500 attendanceBadge"
                v-if="attendaceStatus == '出勤中'"
                >出勤中</sup
              >
              <sup
                class="badge badge-success fw-500 attendanceBadge"
                v-if="attendaceStatus == '外出中'"
                >外出中</sup
              >
              <sup
                class="badge badge-danger fw-500 attendanceBadge"
                v-if="attendaceStatus == '退勤済'"
                >退勤済</sup
              >
            </span>
          </small>
        </h1>
      </div>
      <div class="subheader-block col-md-6">
        <div class="row">
          <div class="ml-auto">
            <div class="loader_attendance" id="loader_attendance">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
          </div>
          <div class="col-sm-auto demo pt-3 workbtnFrame">
            <button
              type="button"
              class="btn btn-info waves-effect waves-themed workbtn"
              :disabled="isDisableWb || isDisableWb4work"
              @click="updAttendance(1)"
            >
              出勤
            </button>
            <button
              type="button"
              class="btn btn-danger waves-effect waves-themed workbtn"
              :disabled="isDisableWb || isDisableWb4leaving"
              @click="updAttendance(2)"
            >
              退勤
            </button>
            <button
              type="button"
              class="btn btn-success waves-effect waves-themed workbtn"
              :disabled="isDisableWb || isDisableWb4gostart"
              @click="updAttendance(3)"
            >
              外出
            </button>
            <button
              type="button"
              class="btn btn-primary waves-effect waves-themed workbtn"
              :disabled="isDisableWb || isDisableWb4goend"
              @click="updAttendance(4)"
            >
              戻り
            </button>
            <div class="btn-group btn-group-sm requestbtnFrame">
              <button
                type="button"
                class="btn btn-primary waves-effect waves-themed requestbtn"
                @click="goTo('/shinsei_Zangyoedit', $event)"
              >
                時間外残業申請
              </button>
              <button
                type="button"
                class="btn btn-primary waves-effect waves-themed requestbtn"
                @click="goTo('/shinsei_Kyukatodokeedit', $event)"
              >
                休暇届
              </button>
            </div>
            <div
              class="row"
              style="display: block; text-align: right"
              v-if="attendaceStatus == '退勤済'"
            >
              <span class="badge badge-info">今日も一日お疲れ様でした</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Your main content goes below here: -->
    <div class="row">
      <div class="col-lg-6">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>新着情報</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
                @click="clickPanelFullScreen(1)"
              ></button>
            </div>
            <div class="panel-toolbar" role="menu">
              <a
                href="#"
                class="btn btn-toolbar-master waves-effect waves-themed"
                data-toggle="dropdown"
                ><i class="fal fa-ellipsis-v"></i
              ></a>
              <div
                class="dropdown-menu dropdown-menu-animated dropdown-menu-right p-0"
              >
                <a @click="get4Alert()" class="dropdown-item js-panel-refresh"
                  ><span data-i18n="drpdwn.refreshpanel">新着情報更新</span></a
                >
              </div>
            </div>
          </div>
          <div class="panel-container show" id="panel-alert">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content">
              <div class="demo-v-spacing dashboardPanelS news">
                <!-- -------------------- -->
                <div v-if="delegate4Alert.items.length != 0">
                  <div
                    v-for="item in delegate4Alert.items"
                    :key="item.c_alert_id!"
                  >
                    <div
                      v-if="item.c_alert_type == 1 || item.c_alert_type == 10"
                      class="alert alert-info"
                      role="alert"
                    >
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                        @click="upd4flagRead(item.c_alert_id!)"
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                      <a
                        href="#"
                        @click="
                          moveDet(
                            item.c_alert_url_link!,
                            item.c_alert_type,
                            item.c_alert_id!
                          )
                        "
                      >
                        {{ item.c_alert_cont }}
                      </a>
                    </div>

                    <div
                      v-if="item.c_alert_type == 2 || item.c_alert_type == 7"
                      class="alert alert-success"
                      role="alert"
                    >
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                        @click="upd4flagRead(item.c_alert_id!)"
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                      <a
                        href="#"
                        @click="
                          moveDet(
                            item.c_alert_url_link!,
                            item.c_alert_type,
                            item.c_alert_id!
                          )
                        "
                      >
                        {{ item.c_alert_cont }}
                      </a>
                    </div>
                    <div
                      v-if="
                        item.c_alert_type == 3 ||
                        item.c_alert_type == 8 ||
                        item.c_alert_type == 9 ||
                        item.c_alert_type == 11
                      "
                      class="alert alert-danger"
                      role="alert"
                    >
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                        @click="upd4flagRead(item.c_alert_id!)"
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                      <a
                        href="#"
                        @click="
                          moveDet(
                            item.c_alert_url_link!,
                            item.c_alert_type,
                            item.c_alert_id!
                          )
                        "
                      >
                        {{ item.c_alert_cont }}
                      </a>
                    </div>
                    <div
                      v-if="
                        item.c_alert_type == 4 ||
                        item.c_alert_type == 6 ||
                        item.c_alert_type == 5
                      "
                      class="alert alert-warning"
                      role="alert"
                    >
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                        @click="upd4flagRead(item.c_alert_id!)"
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                      <a
                        href="#"
                        @click="
                          moveDet(
                            item.c_alert_url_link!,
                            item.c_alert_type,
                            item.c_alert_id!
                          )
                        "
                      >
                        {{ item.c_alert_cont }}
                      </a>
                    </div>
                    <div
                      v-if="item.c_alert_type == 999"
                      class="alert alert-primary"
                      role="alert"
                    >
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                        @click="upd4flagRead(item.c_alert_id!)"
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                      <a
                        href="#"
                        @click="
                          moveDet(
                            item.c_alert_url_link!,
                            item.c_alert_type,
                            item.c_alert_id!
                          )
                        "
                      >
                        {{ item.c_alert_cont }}
                      </a>
                    </div>
                  </div>
                </div>

                <div v-else>新着情報はありません</div>
                <!-- -------------------- -->
              </div>
            </div>
          </div>
        </div>
        <!-- -------------------- -->
        <div id="panel-2" class="panel">
          <div class="panel-hdr">
            <h2>出勤状況</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
                @click="clickPanelFullScreen(2)"
              ></button>
            </div>
            <div class="panel-toolbar" role="menu">
              <a
                href="#"
                class="btn btn-toolbar-master waves-effect waves-themed"
                data-toggle="dropdown"
                ><i class="fal fa-ellipsis-v"></i
              ></a>
              <div
                class="dropdown-menu dropdown-menu-animated dropdown-menu-right p-0"
              >
                <a
                  @click="get4attendanceList()"
                  class="dropdown-item js-panel-refresh"
                  ><span data-i18n="drpdwn.refreshpanel">出勤状況更新</span></a
                >
              </div>
            </div>
          </div>
          <div class="panel-container show" id="panel-attendancelist">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content workStatusFrame">
              <div id="js_default_list" class="js-list-filter">
                <div class="input-group mb-g">
                  <input
                    type="text"
                    class="form-control shadow-inset-2"
                    id="js_default_list_filter"
                    v-model="domAttendanceFilter"
                    placeholder="名前を入力してください"
                    @keyup.enter="get4attendanceList()"
                  />
                  <div class="input-group-append">
                    <div class="input-group-text" @click="get4attendanceList()">
                      <i class="fal fa-search fs-xl"></i>
                    </div>
                  </div>
                </div>
                <ul
                  class="list-group attendanceList"
                  v-if="responce4attendanceListTmp.length != 0"
                >
                  <!-- -------------------- -->
                  <li
                    class="list-group-item"
                    v-for="item in responce4attendanceListTmp"
                    :key="item.c_staff_id!"
                  >
                    <span :data-filter-tags="item.c_staff_name">
                      {{ item.c_staff_name }}</span
                    >
                    <span v-html="cnvData2State(item)"> </span>
                    <span v-html="cnvData2Request(item)"> </span>
                  </li>
                  <!-- -------------------- -->

                  <!-- <li class="list-group-item">
                    <span data-filter-tags="葛谷健一">葛谷健一</span>
                    <span class="badge badge-secondary badge-pill fs-md"
                      >退勤中</span
                    >
                    <span class="badge badge-yukyu badge-pill fs-md"
                      >有給申請
                    </span>

                    <div class="workOverTime">時間外労働時間（当月）　0:00</div>
                  </li> -->
                  <!-- <li class="list-group-item">
                    <span data-filter-tags="亀岡靖">亀岡靖</span>
                    <span class="badge badge-info badge-pill fs-md"
                      >出勤中</span
                    >
                    <span class="badge badge-jikangai badge-pill fs-md"
                      >時間外申請
                    </span>

                    <div class="workOverTime">時間外労働時間（当月）　0:00</div>
                  </li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- -------------------- -->
      </div>
      <div class="col-lg-6">
        <div id="panel-3" class="panel">
          <div class="panel-hdr">
            <h2>社内掲示板</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
                @click="clickPanelFullScreen(3)"
              ></button>
            </div>
            <div class="panel-toolbar" role="menu">
              <a
                href="#"
                class="btn btn-toolbar-master waves-effect waves-themed"
                data-toggle="dropdown"
                ><i class="fal fa-ellipsis-v"></i
              ></a>
              <div
                class="dropdown-menu dropdown-menu-animated dropdown-menu-right p-0"
              >
                <a @click="get4Message()" class="dropdown-item js-panel-refresh"
                  ><span data-i18n="drpdwn.refreshpanel"
                    >社内掲示板更新</span
                  ></a
                >
              </div>
            </div>
          </div>
          <div class="panel-container show" id="panel-message">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content">
              <div class="demo-v-spacing dashboardPanelS internalBoard">
                <!-- -------------------- -->
                <div v-if="delegate4Message.items.length != 0">
                  <div
                    class="panel-tag"
                    style="margin-bottom: 8px"
                    v-for="item in delegate4Message.items"
                    :key="item.c_message_id!"
                  >
                    {{ cnvDatetime2Date(item.c_message_start!.toString())
                    }}<br />
                    {{ item.c_message_cont }}
                  </div>
                </div>
                <div v-else>掲示板に情報はありません</div>
                <!-- -------------------- -->
              </div>
            </div>
          </div>
        </div>
        <div id="panel-4" class="panel">
          <div class="panel-hdr">
            <h2>売上進捗状況</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show" id="panel-profit">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div
              class="panel-content border-faded border-left-0 border-right-0 border-top-0 text-muted d-flex"
            >
              <div class="row">
                <div class="col-auto">年度</div>
                <div class="col-auto">
                  <vSelect
                    :options="opFiscalYear"
                    name="cmdNendo"
                    v-model="domYear"
                    :reduce="(label:any) => label.code"
                    style="width: 70px"
                  ></vSelect>
                </div>

                <div class="col-auto">種類</div>
                <div class="col-auto">
                  <select
                    name="cmdKind"
                    class="form-control form-control-sm"
                    v-model="domType"
                  >
                    <option value="1" selected>現時点</option>
                    <option value="2">売上予定</option>
                  </select>
                </div>

                <div class="col-auto">
                  <button
                    type="button"
                    class="btn btn-primary btn-sm waves-effect waves-themed"
                    @click="get4SalesInfos()"
                  >
                    <span>表示</span>
                  </button>
                </div>
              </div>
            </div>

            <!-- ----------->
            <div class="row salesTable">
              <div class="col-md-12 contCnt">
                <div class="card-group">
                  <div class="card">
                    <div
                      class="w-100 bg-fusion-50 rounded-top border-top-right-radius-0"
                      style="padding: 5px; text-align: center"
                    >
                      東京
                    </div>
                    <div class="card-body ankenCardBody">
                      <p class="card-text cardRow">
                        <span>媒体料</span><br />
                        <span class="profitTableInnerRow profitTablePrice">
                          {{ tokyo_media }}
                        </span>
                      </p>
                      <p class="card-text cardRow">
                        <span>その他</span><br />
                        <span class="profitTableInnerRow profitTablePrice">
                          {{ tokyo_other }}
                        </span>
                      </p>
                      <p class="card-text cardRow sumRow">
                        <span>小計</span><br />
                        <span class="profitTableInnerRow profitTablePrice">
                          {{ tokyo_sub }}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="card">
                    <div
                      class="w-100 bg-fusion-50"
                      style="padding: 5px; text-align: center"
                    >
                      大阪
                    </div>
                    <div class="card-body ankenCardBody">
                      <p class="card-text cardRow">
                        <span>媒体料</span><br />
                        <span class="profitTableInnerRow profitTablePrice">
                          {{ osaka_media }}
                        </span>
                      </p>
                      <p class="card-text cardRow">
                        <span>その他</span><br />
                        <span class="profitTableInnerRow profitTablePrice">
                          {{ osaka_other }}
                        </span>
                      </p>
                      <p class="card-text cardRow sumRow">
                        <span>小計</span><br />
                        <span class="profitTableInnerRow profitTablePrice">
                          {{ osaka_sub }}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="card">
                    <div
                      class="w-100 bg-fusion-50"
                      style="padding: 5px; text-align: center"
                    >
                      名古屋
                    </div>
                    <div class="card-body ankenCardBody">
                      <p class="card-text cardRow">
                        <span>媒体料</span><br />
                        <span class="profitTableInnerRow profitTablePrice">
                          {{ nagoya_media }}
                        </span>
                      </p>
                      <p class="card-text cardRow">
                        <span>その他</span><br />
                        <span class="profitTableInnerRow profitTablePrice">
                          {{ nagoya_other }}
                        </span>
                      </p>
                      <p class="card-text cardRow sumRow">
                        <span>小計</span><br />
                        <span class="profitTableInnerRow profitTablePrice">
                          {{ nagoya_sub }}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="card">
                    <div
                      class="w-100 bg-fusion-50 rounded-top border-top-left-radius-0"
                      style="padding: 5px; text-align: center"
                    >
                      福岡
                    </div>
                    <div class="card-body ankenCardBody">
                      <p class="card-text cardRow">
                        <span>媒体料</span><br />
                        <span class="profitTableInnerRow profitTablePrice">
                          {{ fukuoka_media }}
                        </span>
                      </p>
                      <p class="card-text cardRow">
                        <span>その他</span><br />
                        <span class="profitTableInnerRow profitTablePrice">
                          {{ fukuoka_other }}
                        </span>
                      </p>
                      <p class="card-text cardRow sumRow">
                        <span>小計</span><br />
                        <span class="profitTableInnerRow profitTablePrice">
                          {{ fukuoka_sub }}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="card">
                    <div
                      class="w-100 bg-fusion-50 rounded-top border-top-left-radius-0"
                      style="padding: 5px; text-align: center"
                    >
                      札幌
                    </div>
                    <div class="card-body ankenCardBody">
                      <p class="card-text cardRow">
                        <span>媒体料</span><br />
                        <span class="profitTableInnerRow profitTablePrice">
                          {{ sapporo_media }}
                        </span>
                      </p>
                      <p class="card-text cardRow">
                        <span>その他</span><br />
                        <span class="profitTableInnerRow profitTablePrice">
                          {{ sapporo_other }}
                        </span>
                      </p>
                      <p class="card-text cardRow sumRow">
                        <span>小計</span><br />
                        <span class="profitTableInnerRow profitTablePrice">
                          {{ sapporo_sub }}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- --------------- -->

            <div class="panel-content contents">
              <div class="demo">
                <!-- ------------------------ -->
              </div>
              <div class="demo" style="margin-top: 35px">
                <div class="row">
                  <div class="col-sm-4 d-sm-flex align-items-center">
                    <div class="p-2 mr-3 bg-info-300 rounded">
                      <span
                        class="peity-bar"
                        data-peity='{"fill": ["#fff"], "width": 27, "height": 27 }'
                        style="display: none"
                        >5,3,1,7,9</span
                      ><svg class="peity" height="27" width="27">
                        <rect
                          data-value="5"
                          fill="#fff"
                          x="0.54"
                          y="12"
                          width="4.32"
                          height="15"
                        ></rect>
                        <rect
                          data-value="3"
                          fill="#fff"
                          x="5.94"
                          y="18"
                          width="4.319999999999999"
                          height="9"
                        ></rect>
                        <rect
                          data-value="1"
                          fill="#fff"
                          x="11.34"
                          y="24"
                          width="4.32"
                          height="3"
                        ></rect>
                        <rect
                          data-value="7"
                          fill="#fff"
                          x="16.740000000000002"
                          y="6"
                          width="4.319999999999997"
                          height="21"
                        ></rect>
                        <rect
                          data-value="9"
                          fill="#fff"
                          x="22.139999999999997"
                          y="0"
                          width="4.320000000000004"
                          height="27"
                        ></rect>
                      </svg>
                    </div>
                    <div>
                      <label class="fs-sm mb-0">売上合計</label>
                      <h4 class="font-weight-bold mb-0 profitSum">
                        {{ salesTotal }}
                      </h4>
                    </div>
                  </div>
                  <div class="col-sm-4 d-sm-flex align-items-center">
                    <div class="p-2 mr-3 bg-success-300 rounded">
                      <span
                        class="peity-bar"
                        data-peity='{"fill": ["#fff"], "width": 27, "height": 27 }'
                        style="display: none"
                        >3,4,3,5,5</span
                      ><svg class="peity" height="27" width="27">
                        <rect
                          data-value="3"
                          fill="#fff"
                          x="0.54"
                          y="10.8"
                          width="4.32"
                          height="16.2"
                        ></rect>
                        <rect
                          data-value="4"
                          fill="#fff"
                          x="5.94"
                          y="5.399999999999999"
                          width="4.319999999999999"
                          height="21.6"
                        ></rect>
                        <rect
                          data-value="3"
                          fill="#fff"
                          x="11.34"
                          y="10.8"
                          width="4.32"
                          height="16.2"
                        ></rect>
                        <rect
                          data-value="5"
                          fill="#fff"
                          x="16.740000000000002"
                          y="0"
                          width="4.319999999999997"
                          height="27"
                        ></rect>
                        <rect
                          data-value="5"
                          fill="#fff"
                          x="22.139999999999997"
                          y="0"
                          width="4.320000000000004"
                          height="27"
                        ></rect>
                      </svg>
                    </div>
                    <div>
                      <label class="fs-sm mb-0">予算</label>
                      <h4 class="font-weight-bold mb-0 profitSum">
                        {{ budget }}
                      </h4>
                    </div>
                  </div>
                  <div class="col-sm-4 d-sm-flex align-items-center">
                    <div class="p-2 mr-3 bg-success-500 rounded">
                      <span
                        class="peity-bar"
                        data-peity='{"fill": ["#fff"], "width": 27, "height": 27 }'
                        style="display: none"
                        >6,4,7,5,6</span
                      ><svg class="peity" height="27" width="27">
                        <rect
                          data-value="6"
                          fill="#fff"
                          x="0.54"
                          y="3.8571428571428577"
                          width="4.32"
                          height="23.142857142857142"
                        ></rect>
                        <rect
                          data-value="4"
                          fill="#fff"
                          x="5.94"
                          y="11.571428571428573"
                          width="4.319999999999999"
                          height="15.428571428571427"
                        ></rect>
                        <rect
                          data-value="7"
                          fill="#fff"
                          x="11.34"
                          y="0"
                          width="4.32"
                          height="27"
                        ></rect>
                        <rect
                          data-value="5"
                          fill="#fff"
                          x="16.740000000000002"
                          y="7.714285714285715"
                          width="4.319999999999997"
                          height="19.285714285714285"
                        ></rect>
                        <rect
                          data-value="6"
                          fill="#fff"
                          x="22.139999999999997"
                          y="3.8571428571428577"
                          width="4.320000000000004"
                          height="23.142857142857142"
                        ></rect>
                      </svg>
                    </div>
                    <div>
                      <label class="fs-sm mb-0">達成率</label>
                      <h4 class="font-weight-bold mb-0 profitSum">
                        {{ rate }}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- --------------- -->
    <!-- <div class="row">
      <div class="col-lg-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>営業日報</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
            <div class="panel-toolbar" role="menu">
              <a
                href="#"
                class="btn btn-toolbar-master waves-effect waves-themed"
                data-toggle="dropdown"
                ><i class="fal fa-ellipsis-v"></i
              ></a>
              <div
                class="dropdown-menu dropdown-menu-animated dropdown-menu-right p-0"
              >
                <a class="dropdown-item js-panel-refresh"
                  ><span data-i18n="drpdwn.refreshpanel">新着情報更新</span></a
                >
              </div>
            </div>
          </div>
          <div class="panel-container show" id="panel-alert">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content">
              <div class="demo-v-spacing dashboardPanelS"> -->
    <!-- -------------------- -->
    <!-- <div></div> -->
    <!-- -------------------- -->
    <!-- </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- エラー確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_errorConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalErrorConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="closeModal4ErrorConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            確認
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- エラー確認モーダル -->
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import vSelect from "vue-select";
import { Cl_common } from "@/functions/Cl_common";
import { commonDate } from "xcommon-node/src/common/commonDate";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";

//掲示板関係
import { Cl_message } from "@/functions/Cl_message";
import { Cl_alert } from "@/functions/Cl_alert";
import { DtoMessagesGetReqImple } from "furukawa-common/src/common/dto/DtoMessagesGetReqImple";
import { DtoMessagesGetResImple } from "furukawa-common/src/common/dto/DtoMessagesGetResImple";
import { DtoAlertsGetReqImple } from "furukawa-common/src/common/dto/DtoAlertsGetReqImple";
import { DtoAlertsGetResImple } from "furukawa-common/src/common/dto/DtoAlertsGetResImple";
import { DtoAlertsPutReq } from "furukawa-common/src/common/dto/abst/DtoAlertsPutReq";

//売上進捗状況関係
// import { Cl_salesinfo } from "@/functions/Cl_salesinfo";
// import { DtoSalesInfosGetReq } from "furukawa-common/src/common/dto/abst/DtoSalesInfosGetReq";
// import { DtoSalesInfosGetRes } from "furukawa-common/src/common/dto/abst/DtoSalesInfosGetRes";

//勤怠関係
import { Cl_attendanceImple } from "@/functions/Cl_attendanceImple";
import { DtoAttendancesGetReqImple } from "furukawa-common/src/common/dto/DtoAttendancesGetReqImple";
import { DtoAttendancesGetResImple } from "furukawa-common/src/common/dto/DtoAttendancesGetResImple";
import { DtoAttendancesPostReqImple } from "furukawa-common/src/common/dto/DtoAttendancesPostReqImple";
import { DtoAttendancesPostResImple } from "furukawa-common/src/common/dto/DtoAttendancesPostResImple";
import { DtoStaff4attendancesGetResImple } from "furukawa-common/src/common/dto/DtoStaff4attendancesGetResImple";
import { EntityStaff4attendanceImple } from "furukawa-common/src/common/entity/EntityStaff4attendanceImple";
import {
  CONST_ATTENDANCE_GETMODE_MINE,
  CONST_ATTENDANCE_GETMODE_VIEW,
  CONST_ATTENDANCE_POSTMODE_GOOUTEND,
  CONST_ATTENDANCE_POSTMODE_GOOUTEND_NUM,
  CONST_ATTENDANCE_POSTMODE_GOOUTSTART,
  CONST_ATTENDANCE_POSTMODE_GOOUTSTART_NUM,
  CONST_ATTENDANCE_POSTMODE_LEAVING,
  CONST_ATTENDANCE_POSTMODE_LEAVING_NUM,
  CONST_ATTENDANCE_POSTMODE_WORK,
  CONST_ATTENDANCE_POSTMODE_WORK_NUM,
  CONST_ATTENDANCE_STATUS_GAISYUTU,
  CONST_ATTENDANCE_STATUS_MISYUKIN,
  CONST_ATTENDANCE_STATUS_SYUKIN,
  CONST_ATTENDANCE_STATUS_TAIKIN,
  CONST_OP_HOLIDAY_PART_TYPE,
  CONST_OP_HOLIDAY_TYPE,
  CONST_OP_OVERTIME_TYPE,
  getAttendanceStatusStr,
} from "furukawa-common/src/common/constant/Constants";
import { DtoSalesInfosGetRes } from "furukawa-common/src/common/dto/abst/DtoSalesInfosGetRes";
import { DtoSalesInfosGetReq } from "furukawa-common/src/common/dto/abst/DtoSalesInfosGetReq";
import { Cl_salesinfo } from "@/functions/Cl_salesinfo";
import { CommonDate4FU } from "furukawa-common/src/common/function/CommonDate4FU";

@Options({
  components: {
    Mo_modal_alert,
    vSelect,
  },
})
export default class Dashboard extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  //掲示板関係
  delegate4Message = new DtoMessagesGetResImple();
  //アラート関係
  delegate4Alert = new DtoAlertsGetResImple();
  //売上進捗状関係
  delegate4SalesInfo = new DtoSalesInfosGetRes();
  //勤怠関係
  responce4attendance = new DtoAttendancesGetResImple();
  responce4attendanceList = new DtoStaff4attendancesGetResImple();
  responce4attendanceListTmp: EntityStaff4attendanceImple[] = [];

  domYear: number = CommonDate4FU.cnvDate2Businessperiod(new Date()); // 現在の年を数値として初期値として設定 // 現在の年を初期値として設定

  domType = 1;

  tokyo_media = "";
  tokyo_other = "";
  tokyo_sub = "";
  osaka_media = "";
  osaka_other = "";
  osaka_sub = "";
  nagoya_media = "";
  nagoya_other = "";
  nagoya_sub = "";
  fukuoka_media = "";
  fukuoka_other = "";
  fukuoka_sub = "";
  sapporo_media = "";
  sapporo_other = "";
  sapporo_sub = "";
  salesTotal = "";
  budget = "";
  rate = "";

  domAttendanceFilter = "";

  //勤怠管理ボタン用
  //----------------
  isDisableWb = true;
  isDisableWb4work = true;
  isDisableWb4leaving = true;
  isDisableWb4gostart = true;
  isDisableWb4goend = true;
  attendaceStatus = "";
  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  opFiscalYear = CommonDate4FU.getFiscalYearOptionList();
  //----------------------
  //モーダル用プロパティ
  //----------------------
  message4ModalErrorConf = "";
  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    this.get4attendance();
    this.get4Message();
    this.get4Alert();
    // this.get4SalesInfos();
    this.get4attendanceList();
    this.get4SalesInfos();

    // #6593 出勤状況と売上進捗状況のパネルの初期表示を最小化状態にする
    this.$nextTick(() => {
      const panel2 = document.getElementById("panel-2");
      if (panel2) {
        panel2.classList.add("panel-collapsed");
        const container = document.getElementById("panel-attendancelist");
        if (container) {
          container.classList.remove("show");
          container.classList.add("collapse");
          container.style.height = "0px";
        }
      }
      const panel4 = document.getElementById("panel-4");
      if (panel4) {
        panel4.classList.add("panel-collapsed");
        const container = document.getElementById("panel-profit");
        if (container) {
          container.classList.remove("show");
          container.classList.add("collapse");
          container.style.height = "0px";
        }
      }
    });
  }
  async clickPanelFullScreen(index: number) {
    // 最大化ボタンを押した時の中のコンテンツを縦方向に最大化させる
    let panel = document.getElementById("panel-" + index);
    let classNameArray = ["panel-content", "dashboardPanelS"];

    if (panel?.classList.contains("panel-fullscreen")) {
      for (let i = 0; i < classNameArray.length; i++) {
        let divs = panel?.getElementsByClassName(classNameArray[i]);
        if (divs != null && divs.length > 0) {
          let div = divs[0] as HTMLDivElement;
          div.style.height = "";
        }
      }
    } else {
      for (let i = 0; i < classNameArray.length; i++) {
        let divs = panel?.getElementsByClassName(classNameArray[i]);
        if (divs != null && divs.length > 0) {
          let div = divs[0] as HTMLDivElement;
          div.style.height = "100%";
        }
      }
    }
  }
  //----------------------
  //基本操作用メソッド
  //----------------------
  async get4attendanceList() {
    //ボタン無効＋ローダー表示
    //-----------------
    const panel = document.getElementById("panel-attendancelist");
    panel?.classList.add("enable-loader");
    this.isDisableWb = true;
    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");
      //準備
      //-------
      let dto = new DtoAttendancesGetReqImple();
      dto.getmode = CONST_ATTENDANCE_GETMODE_VIEW;
      //API実行
      //-------
      this.responce4attendanceList =
        await Cl_attendanceImple.get4AttendanceList(dto);
      // Cl_common.logger(this.responce4attendanceList);
      //フィルタリング
      //-------
      this.responce4attendanceListTmp =
        this.responce4attendanceList.items.filter((item) =>
          item.c_staff_name!.includes(this.domAttendanceFilter)
        );
      //ボタンの状態更新
      //-------
      await this.updWorkBtn();
    } catch (error) {
      Cl_common.logger(error);
    } finally {
      //ローダー非表示
      //-----------------
      panel?.classList.remove("enable-loader");
      this.isDisableWb = false;
    }
  }
  //--------------------------------
  /**
   * 勤怠ボタンを読み込む
   */
  async get4attendance() {
    //ボタン無効＋ローダー表示
    //-----------------
    const panel = document.getElementById("loader_attendance");
    panel?.classList.add("enable-loader_attendance");
    this.isDisableWb = true;
    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");
      //準備
      //-------
      let dto = new DtoAttendancesGetReqImple();
      dto.getmode = CONST_ATTENDANCE_GETMODE_MINE;
      //API実行
      //-------
      this.responce4attendance = await Cl_attendanceImple.get4Attendance(dto);
      //ボタンの状態更新
      //-------
      await this.updWorkBtn();
    } catch (error) {
      Cl_common.logger(error);
    } finally {
      //ローダー非表示
      //-----------------
      panel?.classList.remove("enable-loader_attendance");
      this.isDisableWb = false;
    }
  }
  /**
   * 勤怠管理関係のボタンの状態を更新する
   */
  async updWorkBtn() {
    //初期化
    //-------------
    this.isDisableWb4work = true;
    this.isDisableWb4leaving = true;
    this.isDisableWb4gostart = true;
    this.isDisableWb4goend = true;
    this.attendaceStatus = "";
    //データ判定
    //-------------
    if (this.responce4attendance == null) {
      this.isDisableWb4work = true;
      this.isDisableWb4leaving = true;
      this.isDisableWb4gostart = true;
      this.isDisableWb4goend = true;
      return;
    }
    //状態判定
    //-------------
    try {
      let status = getAttendanceStatusStr(
        this.responce4attendance.c_attendance_time_work,
        this.responce4attendance.c_attendance_time_leaving,
        this.responce4attendance.c_attendance_time_goout_start,
        this.responce4attendance.c_attendance_time_goout_end
      );
      switch (status) {
        case CONST_ATTENDANCE_STATUS_MISYUKIN:
          this.isDisableWb4work = false;
          this.isDisableWb4leaving = true;
          this.isDisableWb4gostart = true;
          this.isDisableWb4goend = true;
          this.attendaceStatus = CONST_ATTENDANCE_STATUS_MISYUKIN;
          break;
        case CONST_ATTENDANCE_STATUS_GAISYUTU:
          this.isDisableWb4work = true;
          this.isDisableWb4leaving = true;
          this.isDisableWb4gostart = true;
          this.isDisableWb4goend = false;
          this.attendaceStatus = CONST_ATTENDANCE_STATUS_GAISYUTU;
          break;
        case CONST_ATTENDANCE_STATUS_SYUKIN:
          this.isDisableWb4work = true;
          this.isDisableWb4leaving = false;
          if (this.responce4attendance.c_attendance_time_goout_start != null) {
            //外出済み
            this.isDisableWb4gostart = true;
            this.isDisableWb4goend = true;
          } else {
            //未外出
            this.isDisableWb4gostart = false;
            this.isDisableWb4goend = true;
          }
          this.attendaceStatus = CONST_ATTENDANCE_STATUS_SYUKIN;
          break;
        case CONST_ATTENDANCE_STATUS_TAIKIN:
          this.isDisableWb4work = true;
          this.isDisableWb4leaving = true;
          this.isDisableWb4gostart = true;
          this.isDisableWb4goend = true;
          this.attendaceStatus = CONST_ATTENDANCE_STATUS_TAIKIN;
          break;
        default:
          throw new Error("不正な状態");
      }
    } catch (error) {
      Cl_common.logger("勤怠管理用ボタンでerror");
      this.isDisableWb = true;
      this.isDisableWb4work = true;
      this.isDisableWb4leaving = true;
      this.isDisableWb4gostart = true;
      this.isDisableWb4goend = true;
    }
  }
  /**
   * GPS情報を取得する
   */
  async getGeolocation(): Promise<{
    latitude: number;
    longitude: number;
  } | null> {
    if (!navigator.geolocation) {
      alert("このブラウザは位置情報の取得に対応していません。");
      return null;
    }
    let location: {
      latitude: number;
      longitude: number;
    } | null = null;
    try {
      // eslint-disable-next-line no-undef
      const position = await new Promise<GeolocationPosition>(
        (resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        }
      );
      location = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };
    } catch (error) {
      console.error(error);
      // alert("位置情報の取得に失敗しました。");
      return null;
    }
    return location;
  }
  /**
   * 勤怠情報を更新する
   * 1:出勤ボタン
   * 2:退勤ボタン
   * 3:外出ボタン
   * 4:戻りボタン
   */
  async updAttendance(mode: number) {
    console.log(location);
    //ボタン無効＋ローダー表示
    //-----------------
    const panel = document.getElementById("loader_attendance");
    panel?.classList.add("enable-loader_attendance");
    this.isDisableWb = true;
    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");
      //準備
      //-------
      let dto = new DtoAttendancesPostReqImple();
      switch (mode) {
        case CONST_ATTENDANCE_POSTMODE_WORK_NUM:
          dto.postmode = CONST_ATTENDANCE_POSTMODE_WORK;
          break;
        case CONST_ATTENDANCE_POSTMODE_LEAVING_NUM:
          dto.postmode = CONST_ATTENDANCE_POSTMODE_LEAVING;
          break;
        case CONST_ATTENDANCE_POSTMODE_GOOUTSTART_NUM:
          dto.postmode = CONST_ATTENDANCE_POSTMODE_GOOUTSTART;
          break;
        case CONST_ATTENDANCE_POSTMODE_GOOUTEND_NUM:
          dto.postmode = CONST_ATTENDANCE_POSTMODE_GOOUTEND;
          break;
        default:
          throw new Error("不正なモード");
      }
      //GPS情報取得
      //-------
      const location = await this.getGeolocation();
      Cl_common.logger(location);
      //locationがnull=GPS機能が動作しない場合は打刻不可
      if (location == null) {
        //モーダルのメッセージを設定
        this.message4ModalErrorConf =
          "GPS情報を取得できませんでした、GPSの使用を許可してください";
        //モーダル表示
        const modal: any = this.$refs.Mo_modal_errorConf;
        modal.showModal();
        return;
      }
      dto.lati = location.latitude;
      dto.long = location.longitude;
      //API実行
      //-------
      const res = await Cl_attendanceImple.post4Attendance(dto);
      this.responce4attendance = Object.assign(
        new DtoAttendancesGetResImple(),
        res
      );
      //ボタンの状態更新
      //-------
      await this.updWorkBtn();
      //出勤状況一覧を更新
      //-------
      this.get4attendanceList();
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
      Cl_common.logger(error);
    } finally {
      //ローダー非表示
      //-----------------
      panel?.classList.remove("enable-loader_attendance");
      this.isDisableWb = false;
    }
  }
  /**
   * 勤怠のデータを受け取り、ステータス表示部分のHTMLを返す
   * @param item
   */
  cnvData2State(item: EntityStaff4attendanceImple): string {
    let status = "";

    try {
      status = getAttendanceStatusStr(
        item.c_attendance_time_work,
        item.c_attendance_time_leaving,
        item.c_attendance_time_goout_start,
        item.c_attendance_time_goout_end
      );
    } catch (error) {
      status = "不正値";
    }

    switch (status) {
      case CONST_ATTENDANCE_STATUS_MISYUKIN:
        return '<span class="badge badge-secondary badge-pill fs-md">未出勤</span>';
      case CONST_ATTENDANCE_STATUS_SYUKIN:
        return '<span class="badge badge-info badge-pill fs-md">出勤中</span>';
      case CONST_ATTENDANCE_STATUS_GAISYUTU:
        return '<span class="badge badge-success badge-pill fs-md">外出中</span>';
      case CONST_ATTENDANCE_STATUS_TAIKIN:
        return '<span class="badge badge-danger badge-pill fs-md">退勤済</span>';
      case "不正値":
        return '<span class="badge badge-danger badge-pill fs-md">不正値</span>';
      default:
        return "";
    }
  }

  /**
   * 勤怠のデータを受け取り、申請表示部分のHTMLを返す
   * @param item
   */
  cnvData2Request(item: EntityStaff4attendanceImple): string {
    let res = "";
    let txtTmp: string | undefined = "";
    let txtTmpHoliday: string | undefined = "";

    // 残業申請。
    //-------
    for (let index = 0; index < item.item4requestOvertime.length; index++) {
      txtTmp = CONST_OP_OVERTIME_TYPE.find(
        (e) =>
          e.code === item.item4requestOvertime[index].c_request_overtime_type!
      )?.label;
      if (txtTmp == undefined) {
        txtTmp = "残業申請";
      }

      res +=
        '<a href="/shinsei_Zangyoedit?id=' +
        item.item4requestOvertime[index].c_request_id +
        '"><span class="badge badge-info badge-pill fs-md">' +
        txtTmp +
        " " +
        // this.item.item4requestOvertime[index].c_request_id +
        "</span></a>";
    }

    // 休暇申請。
    //-------
    for (let index = 0; index < item.item4requestHoliday.length; index++) {
      txtTmp = CONST_OP_HOLIDAY_TYPE.find(
        (e) =>
          e.code === item.item4requestHoliday[index].c_request_holiday_type!
      )?.label;
      if (txtTmp == undefined) {
        txtTmp = "休暇申請";
      }
      if (item.item4requestHoliday[index].c_request_holiday_part_type != null) {
        txtTmpHoliday = CONST_OP_HOLIDAY_PART_TYPE.find(
          (e) =>
            e.code ===
            item.item4requestHoliday[index].c_request_holiday_part_type!
        )?.label;

        if (txtTmpHoliday != undefined) {
          txtTmp += ":" + txtTmpHoliday;
        }
      }

      res +=
        '<a href="/shinsei_Kyukatodokeedit?id=' +
        item.item4requestHoliday[index].c_request_id +
        '"><span class="badge badge-success badge-pill fs-md">' +
        txtTmp +
        " " +
        // this.item.item4requestHoliday[index].c_request_id +
        "</span></a>";
    }
    //出張申請。
    //-------
    for (let index = 0; index < item.item4requestBiztrip.length; index++) {
      txtTmp = "出張";

      res +=
        '<a href="/shinsei_Shutchoedit?id=' +
        item.item4requestBiztrip[index].c_request_id +
        '"><span class="badge badge-secondary badge-pill fs-md">' +
        txtTmp +
        " " +
        // this.item.item4requestOvertime[index].c_request_id +
        "</span></a>";
    }

    return res;
  }

  //--------------------------------
  /**
   * 掲示板のデータを読み込む
   */
  async get4Message() {
    //ボタン無効＋ローダー表示
    //-----------------
    const panel = document.getElementById("panel-message");
    panel?.classList.add("enable-loader");
    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");
      //準備
      //-------
      let dto = new DtoMessagesGetReqImple();
      //検索条件設定
      const nowdate = new Date();
      dto.date = new Date(
        nowdate.getFullYear(),
        nowdate.getMonth(),
        nowdate.getDate()
      )
        .toLocaleDateString()
        .replaceAll("/", "-");
      dto.isDashboard = 1;
      //API実行
      //-------
      this.delegate4Message = await Cl_message.getList(dto);
      // console.log("this.delegate4Message");
      // console.log(this.delegate4Message);
    } catch (error) {
      Cl_common.logger(error);
    } finally {
      //ローダー非表示
      //-----------------
      panel?.classList.remove("enable-loader");
    }
  }
  //--------------------------------
  /**
   * アラートのデータを読み込む
   */
  async get4Alert() {
    //ボタン無効＋ローダー表示
    //-----------------
    const panel = document.getElementById("panel-alert");
    panel?.classList.add("enable-loader");
    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");
      //準備
      //-------
      this.delegate4Alert = new DtoAlertsGetResImple();
      let dto = new DtoAlertsGetReqImple();
      //検索条件設定
      const nowdate = new Date();
      dto.date = new Date(
        nowdate.getFullYear(),
        nowdate.getMonth(),
        nowdate.getDate()
      )
        .toLocaleDateString()
        .replaceAll("/", "-");
      dto.isDashboard = 1;
      //API実行
      //-------
      this.delegate4Alert = await Cl_alert.getList(dto);
      Cl_common.logger("this.delegate4Alert");
      Cl_common.logger(this.delegate4Alert);
    } catch (error) {
      this.delegate4Alert = new DtoAlertsGetResImple();
      Cl_common.logger(error);
    } finally {
      //ローダー非表示
      //-----------------
      panel?.classList.remove("enable-loader");
    }
  }
  /**
   * アラートのデータを既読にする
   */
  async upd4flagRead(id: number) {
    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");
      let dto = new DtoAlertsPutReq();
      dto.c_alert_id = id;
      dto.c_alert_flag_read = 1;
      //API実行
      //-------
      await Cl_alert.put(dto);
    } catch (error) {
      Cl_common.logger(error);
    } finally {
      //-----------------
    }
  }
  //--------------------------------
  /**
   * 売上進捗状況を読み込む
   */
  async get4SalesInfos() {
    //ボタン無効＋ローダー表示
    //-----------------
    const panel = document.getElementById("panel-profit");
    panel?.classList.add("enable-loader");
    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");
      //準備
      //-------
      this.delegate4SalesInfo = new DtoSalesInfosGetRes();
      let dto = new DtoSalesInfosGetReq();
      let total = 0;
      //検索条件設定
      dto.year = CommonDate4FU.cnvBusinessperiod2Date(
        this.domYear
      )[1].getFullYear();
      dto.type = this.domType;
      dto.businessPeriod = this.domYear;
      //API実行
      //-----
      // console.log("dto.year");
      // console.log(dto.year);
      // console.log("dto");
      // console.log(dto);
      this.delegate4SalesInfo = await Cl_salesinfo.get(dto);
      // console.log("this.delegate4SalesInfo");
      // console.log(this.delegate4SalesInfo);
      this.tokyo_media =
        "¥" + this.delegate4SalesInfo.tokyo_media.toLocaleString() + "-";
      this.tokyo_other =
        "¥" + this.delegate4SalesInfo.tokyo_other.toLocaleString() + "-";
      if (
        this.delegate4SalesInfo.tokyo_media != null &&
        this.delegate4SalesInfo.tokyo_other != null
      ) {
        this.tokyo_sub =
          "¥" +
          (
            this.delegate4SalesInfo.tokyo_media +
            this.delegate4SalesInfo.tokyo_other
          ).toLocaleString();

        total +=
          this.delegate4SalesInfo.tokyo_media +
          this.delegate4SalesInfo.tokyo_other;
      }

      this.osaka_media =
        "¥" + this.delegate4SalesInfo.osaka_media.toLocaleString() + "-";
      this.osaka_other =
        "¥" + this.delegate4SalesInfo.osaka_other.toLocaleString() + "-";
      if (
        this.delegate4SalesInfo.osaka_media != null &&
        this.delegate4SalesInfo.osaka_other != null
      ) {
        this.osaka_sub =
          "¥" +
          (
            this.delegate4SalesInfo.osaka_media +
            this.delegate4SalesInfo.osaka_other
          ).toLocaleString();
        total +=
          this.delegate4SalesInfo.osaka_media +
          this.delegate4SalesInfo.osaka_other;
      }

      this.nagoya_media =
        "¥" + this.delegate4SalesInfo.nagoya_media.toLocaleString() + "-";
      this.nagoya_other =
        "¥" + this.delegate4SalesInfo.nagoya_other.toLocaleString() + "-";
      if (
        this.delegate4SalesInfo.nagoya_media != null &&
        this.delegate4SalesInfo.nagoya_other != null
      ) {
        this.nagoya_sub =
          "¥" +
          (
            this.delegate4SalesInfo.nagoya_media +
            this.delegate4SalesInfo.nagoya_other
          ).toLocaleString();
        total +=
          this.delegate4SalesInfo.nagoya_media +
          this.delegate4SalesInfo.nagoya_other;
      }

      this.fukuoka_media =
        "¥" + this.delegate4SalesInfo.fukuoka_media.toLocaleString() + "-";
      this.fukuoka_other =
        "¥" + this.delegate4SalesInfo.fukuoka_other.toLocaleString() + "-";
      if (
        this.delegate4SalesInfo.fukuoka_media != null &&
        this.delegate4SalesInfo.fukuoka_other != null
      ) {
        this.fukuoka_sub =
          "¥" +
          (
            this.delegate4SalesInfo.fukuoka_media +
            this.delegate4SalesInfo.fukuoka_other
          ).toLocaleString();
        total +=
          this.delegate4SalesInfo.fukuoka_media +
          this.delegate4SalesInfo.fukuoka_other;
      }

      this.sapporo_media =
        "¥" + this.delegate4SalesInfo.sapporo_media.toLocaleString() + "-";
      this.sapporo_other =
        "¥" + this.delegate4SalesInfo.sapporo_other.toLocaleString() + "-";
      if (
        this.delegate4SalesInfo.sapporo_media != null &&
        this.delegate4SalesInfo.sapporo_other != null
      ) {
        this.sapporo_sub =
          "¥" +
          (
            this.delegate4SalesInfo.sapporo_media +
            this.delegate4SalesInfo.sapporo_other
          ).toLocaleString();
        total +=
          this.delegate4SalesInfo.sapporo_media +
          this.delegate4SalesInfo.sapporo_other;
      }

      this.salesTotal = "¥" + total.toLocaleString();

      // this.salesTotal =
      //   "¥" + this.delegate4SalesInfo.salesTotal.toLocaleString() + "-";
      this.budget = "¥" + this.delegate4SalesInfo.budget.toLocaleString() + "-";

      if (0 != total && 0 < this.delegate4SalesInfo.budget) {
        this.rate =
          ((total / this.delegate4SalesInfo.budget) * 100).toFixed(2) + "%";
      } else {
        this.rate = "0%";
      }
    } catch (error) {
      this.delegate4SalesInfo = new DtoSalesInfosGetRes();
      Cl_common.logger(error);
    } finally {
      //ローダー非表示
      //-----------------
      panel?.classList.remove("enable-loader");
    }
  }
  //--------------------------------
  async moveDet(link: string, type: number, id: number) {
    //タイプによって、画面遷移と同時に既読にする
    //-------------------
    if (type != 1 && type != 6 && type != 10 && type != 11) {
      await this.upd4flagRead(id);
    }
    //詳細ページに移動
    this.$router.push(link);
  }
  /**
   * 日付のフォーマット調整
   * @param date
   */
  cnvDatetime2Date(date: string): string {
    return date.split("T")[0].replaceAll("-", "/");
  }
  /**
   * 画面遷移用
   * @param url
   * @param event
   */

  async goTo(url: string, event?: MouseEvent) {
    Cl_common.goTo(url, this.$router, event);
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
  async closeModal4ErrorConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_errorConf;
    modal.closeModal();
  }
}
</script>

<style scoped>
.dashboardPanelS {
  overflow-x: hidden;
  overflow-y: auto;
  height: 220px;
  padding-right: 20px;
}

.profitLevel_title,
.profitLevel_price {
  margin-bottom: 0px;
}

.profitSum {
  /* font-weight: normal; */
  overflow-wrap: break-word;
}

.alert-success {
  color: #45a197;
  background-color: #f7fdfc;
  border-color: #a3ebe4;
}

.alert a {
  text-decoration: none;
  color: inherit;
}
li.list-group-item span:first-child {
  width: 130px;
  display: inline-block;
}
.workStatusFrame {
  height: 450px;
  overflow: auto;
}
.badge-daikyu {
  color: #fff;
  background-color: #372dbe;
}
.badge-yukyu {
  color: #fff;
  background-color: #a62dbe;
}
.badge-jikangai {
  color: #fff;
  background-color: #be2d2d;
}
.badge-remote {
  color: #fff;
  background-color: #2dbe34;
}
.badge-shutcho {
  color: #fff;
  background-color: #bea32d;
}
li.list-group-item span.badge {
  margin-left: 1rem;
}
.workOverTime {
  text-align: right;
  margin-top: 0.5rem;
}

.loader_attendance {
  padding-top: 20px;
  display: none;
}
.workbtnFrame button:disabled {
  background-color: #505050;
  border-color: #505050;
}

.enable-loader_attendance {
  display: block !important;
}

.attendanceBadge {
  position: unset !important;
}

.salesTable {
  margin: 18px 0px 0 0px;
}

.card-text {
  font-size: 12px;
}
.profitTablePrice {
  display: block;
  widows: 100%;
  text-align: right;
}
.sumRow {
  border-top: 1px solid #e5e5e5;
  font-weight: 700;
  padding-top: 8px;
}
.cardRow > span:first-child {
  font-weight: bold;
  /* margin-right: 10px; */
  /* display: block;
  float: left;
  width: 50%; */
}

.requestbtn {
  padding: 8px;
}

@media only screen and (max-width: 576px) {
  .workbtn {
    width: 100%;
    padding: 0.75rem 1.5rem;
    font-size: large;
  }

  .requestbtnFrame {
    width: 100%;
  }
  .requestbtn {
    width: 100%;
    padding: 0.75rem 1.5rem;
    font-size: large;
  }

  li.list-group-item span:nth-child(2) {
    margin-left: 0;
  }
  li.list-group-item span:nth-child(3) {
    margin-left: 0.5rem;
  }

  .loader_attendance {
    text-align: left;
  }

  .news,
  .internalBoard {
    overflow-y: unset;
    height: unset;
  }
  .attendanceList > li > span:first-child {
    display: block;
  }
}
</style>
